import { toast } from 'react-toastify';

const allowedImagesType = ['jpg', 'png', 'jpeg'];

export const debounce = (func, delay) => {
  let timeoutId;

  return () => {
    console.log('debounce :::::::::: timeoutId ::::::::::: ', {
      timeoutId,
      delay
    });
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func.apply(this, arguments);
    }, delay);
  };
};

export const handleDebounce = (callbackFunction, delay) => {
  console.log('handleDebounce :::::::: ', { delay });
  debounce(callbackFunction, delay)();
};

export const beforeUpload = file => {
  const fileType = file.name
    .slice(file.name.lastIndexOf('.') + 1, file.name.length)
    .toLowerCase();
  const isJpgOrPng = allowedImagesType.includes(fileType);
  if (!isJpgOrPng) {
    toast.error('You can only upload JPEG/JPG/PNG file!');
  }

  const isLt2M = file.size / 1024 / 1024 < 5;
  if (!isLt2M) {
    toast.error('Image must smaller than 5MB!');
  }

  return isJpgOrPng && isLt2M;
};

export const beforeUploadXlsx = file => {
  const fileType = file.name
    .slice(file.name.lastIndexOf('.') + 1)
    .toLowerCase();
  const isXlsx = fileType === 'xlsx';

  if (!isXlsx) {
    toast.error('You can only upload XLSX files!');
  }

  const isLt5M = file.size / 1024 / 1024 < 5;
  if (!isLt5M) {
    toast.error('File must be smaller than 5MB!');
  }

  return isXlsx && isLt5M;
};

export const getBase64FromImage = async file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
};
